module.exports = __webpack_public_path__ + "img/engine.642fdfca.svg";